package com.iptvplayer.web

import com.iptvplayer.shared.di.commonModule
import com.iptvplayer.shared.di.platformModule
import com.iptvplayer.web.ui.App
import org.jetbrains.compose.web.renderComposable
import org.koin.core.context.startKoin

fun main() {
    startKoin {
        modules(commonModule, platformModule)
    }
    renderComposable(rootElementId = "root") {
        App()
    }
}
